import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Shield, Zap, Eye, Activity,
  Code2, Map, ChevronDown, Menu, X
} from 'lucide-react';
import './Navbar.css';

const services = [
  { name: '托管安全运营', path: '/services/security-ops', icon: <Shield size={22} />, desc: '7×24小时全天候安全监控与响应' },
  { name: '深度渗透测试', path: '/services/pen-test', icon: <Eye size={22} />, desc: '专业级攻防实战化漏洞挖掘' },
  { name: '极速应急响应', path: '/services/emergency-response', icon: <Zap size={22} />, desc: '15分钟内建立远程安全作战室' },
  { name: '持续漏洞扫描', path: '/services/vuln-scan', icon: <Activity size={22} />, desc: '全面资产覆盖与持续性订阅' },
  { name: '代码审计服务', path: '/services/code-audit', icon: <Code2 size={22} />, desc: '白盒源码安全审查与风险评估' },
  { name: '资产测绘服务', path: '/services/asset-mapping', icon: <Map size={22} />, desc: '全息互联网资产暴露面识别' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setServicesOpen(false);
  }, [location]);

  const handleServiceMouseEnter = () => {
    clearTimeout(timerRef.current);
    setServicesOpen(true);
  };

  const handleServiceMouseLeave = () => {
    timerRef.current = setTimeout(() => setServicesOpen(false), 150);
  };

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="container navbar__inner">
        {/* Logo */}
        <Link to="/" className="navbar__logo">
          <img src={process.env.PUBLIC_URL + '/logo.png'} alt="卓迈科技" className="navbar__logo-img" />
          <div className="navbar__logo-text">
            <span className="navbar__logo-main">卓迈科技</span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <ul className="navbar__links">
          <li>
            <Link to="/" className={`navbar__link ${location.pathname === '/' ? 'active' : ''}`}>
              首页
            </Link>
          </li>

          {/* 服务下拉 */}
          <li
            className="navbar__dropdown-wrapper"
            onMouseEnter={handleServiceMouseEnter}
            onMouseLeave={handleServiceMouseLeave}
            ref={dropdownRef}
          >
            <button className={`navbar__link navbar__link--dropdown ${isActive('/services') ? 'active' : ''}`}>
              安全服务
              <ChevronDown size={14} className={`navbar__chevron ${servicesOpen ? 'rotated' : ''}`} />
            </button>

            {servicesOpen && (
              <div className="navbar__dropdown">
                <div className="navbar__dropdown-header">
                  <Zap size={14} />
                  <span>专业安全服务体系</span>
                </div>
                <div className="navbar__dropdown-grid">
                  {services.map((svc) => (
                    <Link
                      key={svc.path}
                      to={svc.path}
                      className={`navbar__dropdown-item ${isActive(svc.path) ? 'active' : ''}`}
                    >
                      <span className="navbar__dropdown-item-icon">{svc.icon}</span>
                      <div>
                        <div className="navbar__dropdown-item-name">{svc.name}</div>
                        <div className="navbar__dropdown-item-desc">{svc.desc}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </li>

          <li>
            <Link to="/about" className={`navbar__link ${isActive('/about') ? 'active' : ''}`}>
              关于我们
            </Link>
          </li>
          <li>
            <Link to="/contact" className="btn btn-primary btn-sm">
              联系我们
            </Link>
          </li>
        </ul>

        {/* Mobile toggle */}
        <button className="navbar__mobile-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="navbar__mobile-menu">
          <Link to="/" className="navbar__mobile-link">首页</Link>
          <div className="navbar__mobile-section">
            <div className="navbar__mobile-section-title">安全服务</div>
            {services.map((svc) => (
              <Link key={svc.path} to={svc.path} className="navbar__mobile-link navbar__mobile-link--sub">
                <span>{svc.icon}</span> {svc.name}
              </Link>
            ))}
          </div>
          <Link to="/about" className="navbar__mobile-link">关于我们</Link>
          <Link to="/contact" className="navbar__mobile-link">联系我们</Link>
        </div>
      )}
    </nav>
  );
}
